import { useTranslation } from "react-i18next";
import type { ProjectedHumanStep } from "../../../api/threads/liveMessages";
import Chip from "../../../ui/feedback/Chip";
import SpinnerIcon from "../../../ui/feedback/SpinnerIcon";
import type { ChipTone } from "../../../ui/styles/chipStyles";
import { requestWaitText } from "./requestWaitWords";
import type { ThreadDisplayStatus } from "./threadStatus";

const STATUS_TONE: Readonly<Record<ThreadDisplayStatus, ChipTone>> = {
  live: "success",
  working: "info",
  waiting: "info",
  approval: "warning",
  input: "warning",
  failed: "danger",
  saved: "neutral",
  closed: "neutral",
};

interface ThreadStatusBadgeProps {
  status: ThreadDisplayStatus;
  /** The person step that waits, from the same projection, and the host's name (`null` when the viewer hosts): Input then says whom it waits for. */
  request?: { readonly step: ProjectedHumanStep; readonly hostName: string | null } | null;
  compact?: boolean;
  className?: string;
}

/** One status per Thread, the same in the list and on the page. */
export default function ThreadStatusBadge({ status, request = null, compact = false, className }: ThreadStatusBadgeProps) {
  const { t } = useTranslation();
  return (
    <Chip
      tone={STATUS_TONE[status]}
      size={compact ? "compact" : "small"}
      title={status === "input" && request !== null ? requestWaitText(request.step, null, request.hostName, t) : t(`threads.status.${status}.explanation`)}
      icon={status === "working" ? <SpinnerIcon className="h-3 w-3" /> : null}
      className={className === undefined ? "shrink-0" : `shrink-0 ${className}`}
    >
      {t(`threads.status.${status}.label`)}
    </Chip>
  );
}
